import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

import Price from 'Components/Utility/Price/Price';
import SpecialFormattedNumber from 'Components/Utility/Price/SpecialFormattedNumber';

const ProductCouponPrice = ({
  price,
  hideDiscount,
  currentDiscount,
  couponDiscountPercent,
  totalSavingPercent,
  type,
  fullPrice,
  mystery,
}) => {
  const currentDiscountPercent = _get(currentDiscount, 'percent', 0);
  let savingToDisplay = Math.abs((totalSavingPercent / 100));
  if (savingToDisplay > 0.99) savingToDisplay = 0.99;
  return (
    <div className="PriceContainer">
      <div className="PriceContainer__price">
        <b>
          <Price
            showZero
            type={type}
            price={price}
            discount={currentDiscountPercent}
            bonusDiscount={couponDiscountPercent}
          />
        </b>
      </div>
      {!hideDiscount &&
        <div className="PriceContainer__wasPrice">
          <Price
            price={(type === 'bundle' && !mystery) ? fullPrice : price}
          />
        </div>
      }
      {/* eslint-disable react/style-prop-object */}
      {!hideDiscount &&
        <div className="PriceContainer__savingPercentage">
          <React.Fragment> -<SpecialFormattedNumber value={savingToDisplay} style="percent" />  </React.Fragment>
        </div>
      }
    </div>
  );
};

ProductCouponPrice.propTypes = {
  price: PropTypes.shape({}).isRequired,
  hideDiscount: PropTypes.bool,
  currentDiscount: PropTypes.number.isRequired,
  couponDiscountPercent: PropTypes.number,
  totalSavingPercent: PropTypes.number,
  type: PropTypes.string,
  fullPrice: PropTypes.shape({}),
  mystery: PropTypes.bool,
};

ProductCouponPrice.defaultProps = {
  hideDiscount: false,
  couponDiscountPercent: null,
  totalSavingPercent: null,
  type: '',
  fullPrice: {},
  mystery: false,
};

export default ProductCouponPrice;
